import { useEffect, useState } from "react";
import { Sparkles, Loader2, Plus, TrendingUp, TrendingDown, Wand2, ChevronDown, ChevronUp } from "lucide-react";
import { axiosInstance } from "../../App";
import { Button } from "@/components/ui/button";

const GROUP_STYLES = {
  opening: "text-gray-700",
  strength: "text-emerald-700",
  improve: "text-amber-700",
  home: "text-sky-700",
  closing: "text-purple-700",
};

// Panel cadangan komen siap berdasarkan domain terkuat & terlemah anak
export default function CommentSuggestions({ childId, ageRanges, onInsert, onUseFull }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const ageKey = (ageRanges || []).join(",");

  useEffect(() => { setData(null); }, [childId, ageKey]);

  useEffect(() => {
    if (!open || data || !childId) return;
    let active = true;
    setLoading(true);
    setError("");
    axiosInstance
      .get(`/development/comment-suggestions/${childId}`, { params: ageKey ? { age_ranges: ageKey } : {} })
      .then((res) => { if (active) setData(res.data); })
      .catch((e) => { if (active) setError(e.response?.data?.detail || "Ralat memuatkan cadangan"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open, data, childId, ageKey]);

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/60" data-testid="comment-suggestions">
      <button
        type="button"
        data-testid="comment-suggestions-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-amber-800">
          <Sparkles className="w-4 h-4" /> Templat Komen
          <span className="font-normal text-xs text-amber-700/80 hidden sm:inline">ikut kekuatan &amp; kelemahan anak</span>
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-amber-700" /> : <ChevronDown className="w-4 h-4 text-amber-700" />}
      </button>

      {open && (
        <div className="px-3 pb-3 space-y-3">
          {loading && (
            <div className="flex items-center gap-2 text-sm text-gray-500 py-2"><Loader2 className="w-4 h-4 animate-spin" /> Menganalisis perkembangan...</div>
          )}
          {error && <p className="text-sm text-red-600">{error}</p>}
          {data && (
            <>
              <div className="flex flex-wrap gap-2" data-testid="suggestion-domains">
                {data.strongest.map((s) => (
                  <span key={`s-${s.category}`} className="inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-800 px-2.5 py-1 text-xs font-semibold">
                    <TrendingUp className="w-3.5 h-3.5" /> Kuat: {s.label} {s.percentage}%
                  </span>
                ))}
                {data.weakest.map((s) => (
                  <span key={`w-${s.category}`} className="inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 px-2.5 py-1 text-xs font-semibold">
                    <TrendingDown className="w-3.5 h-3.5" /> Perlu galakan: {s.label} {s.percentage}%
                  </span>
                ))}
              </div>

              <Button
                type="button" size="sm" data-testid="suggestion-use-full"
                onClick={() => onUseFull(data.full_comment)}
                className="bg-amber-600 hover:bg-amber-700 text-white"
              >
                <Wand2 className="w-4 h-4 mr-1.5" /> Guna Komen Lengkap
              </Button>

              <div className="space-y-3 max-h-64 overflow-y-auto pr-1">
                {data.groups.map((g) => (
                  <div key={g.key}>
                    <p className={`text-xs font-bold uppercase tracking-wide mb-1.5 ${GROUP_STYLES[g.key] || "text-gray-700"}`}>{g.title}</p>
                    <div className="space-y-1.5">
                      {g.sentences.map((sentence, i) => (
                        <button
                          type="button"
                          key={`${g.key}-${i}`}
                          data-testid={`suggestion-${g.key}-${i}`}
                          onClick={() => onInsert(sentence)}
                          className="group w-full flex items-start gap-2 text-left text-sm text-gray-700 bg-white border border-gray-200 rounded-lg px-2.5 py-2 hover:border-amber-400 hover:bg-amber-50 transition-colors duration-150"
                        >
                          <Plus className="w-4 h-4 mt-0.5 shrink-0 text-amber-600 group-hover:text-amber-700" />
                          <span>{sentence}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-[11px] text-gray-500">Klik ayat untuk tambah ke komen. Anda boleh ubah suai sebelum menyimpan.</p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
